import { render, staticRenderFns } from "./TranslateContentButton.vue?vue&type=template&id=036d9b74&scoped=true&"
import script from "./TranslateContentButton.vue?vue&type=script&lang=js&"
export * from "./TranslateContentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d9b74",
  null
  
)

export default component.exports